module.exports = __webpack_public_path__ + "static/media/montblanc-what-moves-you-makes-you-3.8326a807.jpg";